// @flow

import React, { type Element } from 'react'
import { Box, Grid } from '@material-ui/core'
import grey from '@material-ui/core/colors/grey'

type PrivateFacilityProps = {|
  message: string,
  close: () => void,
|}

function SuccessMessage({ message, close }: PrivateFacilityProps): Element<typeof React.Fragment> {
  return (
    <Grid item xs={12}>
      <Box className="flash-alert flash-alert-success">
        <Grid container justify="space-between">
          <span>{message}</span>
          <Box
            component="span"
            style={{ cursor: 'pointer' }}
            onClick={close}
            color={grey[400]}
            fontSize={20}
            data-testid="alert_success_close"
          >
            &times;
          </Box>
        </Grid>
      </Box>
    </Grid>
  )
}

export default SuccessMessage
